import { CheckCircle, Clock, X } from "lucide-react";

// Database status mapping to UI display
export const statusDisplayMap = {
  'sent': 'Issued',
  'paid': 'Paid',
  'overdue': 'Overdue'
} as const;

export const statusOptions = ["sent", "paid"];

export const getStatusColor = (status: string) => {
  switch (status) {
    case "paid": return "bg-green-100 text-green-800";
    case "sent": return "bg-blue-100 text-blue-800";
    case "overdue": return "bg-red-100 text-red-800";
    default: return "bg-gray-100 text-gray-800";
  }
};

export const getStatusIcon = (status: string) => {
  switch (status) {
    case "paid": return CheckCircle;
    case "sent": return Clock;
    case "overdue": return X;
    default: return Clock;
  }
};

// Utility function to determine invoice status based on due date
export const getInvoiceStatus = (invoice: { status?: string; due_date?: string; paid_date?: string }) => {
  // If already paid (either by status or paid_date), return paid
  if (invoice.status === 'paid' || invoice.paid_date) {
    return 'paid';
  }
  
  // If no due date, keep as sent
  if (!invoice.due_date) {
    return 'sent';
  }
  
  // Check if deadline has passed
  const dueDate = new Date(invoice.due_date);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to start of day for fair comparison
  dueDate.setHours(0, 0, 0, 0);
  
  if (dueDate < today) {
    return 'overdue';
  }
  
  return 'sent';
};

// Type definitions
export type InvoiceStatus = keyof typeof statusDisplayMap;
